module.exports = __webpack_public_path__ + "img/CV.Drainage.Gullies.Concrete_Gully.8cc20e09.png";